import type { SVGProps } from 'react';

export const Warning = (props: SVGProps<any>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 -2 32 36"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'warning'}</title>
    <g
      fill={props.fill}
      fillRule="evenodd"
      stroke={props.stroke}
      strokeWidth="1"
    >
      <path
        d="M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M16,1.68421053 C8.09360779,1.68421053 1.68421053,8.09360779 1.68421053,16 C1.68421053,23.9063922 8.09360779,30.3157895 16,30.3157895 C23.9063922,30.3157895 30.3157895,23.9063922 30.3157895,16 C30.3157895,8.09360779 23.9063922,1.68421053 16,1.68421053 Z M17,23 L17,25 L15,25 L15,23 L17,23 Z M17,8 L17,13.6470588 L16.6,21.1764706 L15.401,21.1764706 L15,13.6470588 L15,8 L17,8 Z"
        fill={props.fill}
      />
    </g>
  </svg>
);
